import * as z from 'zod';
import {
  optionalText,
  requiredEmail,
  requiredPhoneSchema,
  requiredText,
} from '@/modules/service-requests/shared/application-utils';

export const idCardApplySchema = z
  .object({
    firstName: requiredText('FIRST_NAME_REQUIRED', 100),
    lastName: requiredText('LAST_NAME_REQUIRED', 100),
    email: requiredEmail('EMAIL_REQUIRED'),
    mobileNumber: requiredPhoneSchema('PHONE_NUMBER_REQUIRED'),
    bloodGroup: z.string().trim().min(1, { message: 'BLOOD_GROUP_REQUIRED' }),
    designation: requiredText('DESIGNATION_REQUIRED', 150),
    employeeId: requiredText('EMPLOYEE_ID_REQUIRED', 50),
    applicationType: z.enum(['NewJoiner', 'Reissue']),
    paymentMethod: z.string().optional(),
    paymentReference: optionalText(100).optional(),
  })
  // Only a re-issue is paid for, so only then must a payment method be chosen.
  .refine(
    (values) => values.applicationType !== 'Reissue' || Boolean(values.paymentMethod?.trim()),
    {
      message: 'PAYMENT_METHOD_REQUIRED',
      path: ['paymentMethod'],
    }
  );

export type IdCardApplyValues = z.infer<typeof idCardApplySchema>;
